import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';

import PublicMap from './components/PublicMap';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const urlParams = new URLSearchParams(window.location.search);
const embedSlug = urlParams.get('embed');

const root = ReactDOM.createRoot(rootElement);

if (embedSlug) {
    root.render(
        <React.StrictMode>
            <PublicMap slug={embedSlug} />
        </React.StrictMode>
    );
} else {
    root.render(
        <React.StrictMode>
            <App />
        </React.StrictMode>
    );
}